const HEADER_TYPE_MAP = {
  H1: "header-one",
  H2: "header-two",
  H3: "header-three",
  H4: "header-four",
  H5: "header-five",
  H6: "header-six",
  P: "unstyled"
};
const DEFAULT_HEADERS_DROPDOWN_OPTIONS = ["P", "H1", "H2", "H3", "H4", "H5", "H6"];
const PLUGIN_DECORATIONS = Object.freeze({
  RESIZEABLE: "RESIZEABLE"
});
const PLUGIN_DECORATION_PROPS = Object.freeze({
  [PLUGIN_DECORATIONS.RESIZEABLE]: (props) => ({
    onMouseDown: props.onMouseDown,
    onMouseMove: props.onMouseMove,
    onMouseLeave: props.onMouseLeave,
    style: props.style,
    width: props.width,
    containerClassName: props.containerClassName
  })
});
const TOOLBAR_OFFSETS = Object.freeze({
  top: 12,
  left: 15
});
const UNSUPPORTED_BLOCKS_TYPE = "unsupported-blocks";

export { DEFAULT_HEADERS_DROPDOWN_OPTIONS, HEADER_TYPE_MAP, PLUGIN_DECORATIONS, PLUGIN_DECORATION_PROPS, TOOLBAR_OFFSETS, UNSUPPORTED_BLOCKS_TYPE };
//# sourceMappingURL=consts.js.map
